import React, { useState } from 'react'
import Background from 'src/components/background'
import { SidebarProvider } from 'src/components/ui/sidebar'
import { Outlet } from 'react-router-dom'
import { SidebarNav } from './sidebar'
import { Header } from 'src/components/header/newheader'
import { useIsMobile } from '../../../hooks/use-mobile'

interface DashboardLayoutProps {
  children: React.ReactNode
}

export function NewDashboardLayout({ children }: DashboardLayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const isMobile = useIsMobile()

  return (
    <div className="min-h-screen bg-background">
      <SidebarNav collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />

      <div className={`transition-all duration-300 ${sidebarCollapsed ? 'ml-16' : 'ml-16 md:ml-sidebar'}`}>
        {/*<Header onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)} />*/}
        <Header />

        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export function getUpdatedAdminLayout(page: React.ReactNode) {
  return <NewDashboardLayout>{page}</NewDashboardLayout>
}
